import React, { useEffect, useState } from "react";
import Footer from "../footer";

import { List, Search } from "react-feather";
import Header2 from "../header2/index-two";
import ListKat from "../listkat/ListKat";
import axios from "axios";
import PropTypes from 'prop-types'; 
import { Link, useParams } from "react-router-dom";

export const Kategory = () => {
  const {commo} = useParams();
  
  const [kates, setKates] = useState([])
  const [subkat, setSubkat] = useState([])
  const [parameter, setParameter] = useState([])

  const [komo, setKomo] = useState('')
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')
  const [image, setImage] = useState('')
  const [query, setQuery] = useState('')

  console.log('query =', query)

  useEffect(()=>{
    const getKate = async() =>{
      setLoading(true)
      setError('')
      let response
      try {
        if(commo === 'pangan'){
          setKomo('Pangan')
          setImage('pangan')
        }else if(commo === 'kosmetik'){
          setKomo('Kosmetik')
          setImage('kosmetik')
        }else if(commo === 'obat'){
          setKomo('Obat')
          setImage('obat')
        }else if(commo === 'obat-bahan-alam'){
          setKomo('Obat Bahan Alam')
          setImage('ot')
        }

        console.log(commo)
        response = await axios.get(`https://bbpom-makassar.com/api/kategory/${commo}`)
        setKates(response.data.data)
        setSubkat(response.data.sub)
        setParameter(response.data.par)
        setLoading(false)
      } catch (e) {
        console.log(e.message)
        setKates([])
        setError('Data komoditi gagal dimuat. Periksa alamat halaman, lalu coba lagi.')
        setLoading(false)
      }
    }

    getKate()
  },[commo])
 
  // Hitungan sub-kategori dan parameter datang sebagai array sejajar posisi dengan
  // `kates`. Gabungkan dulu ke masing-masing kategori supaya angkanya ikut terbawa
  // saat daftar disaring — sebelumnya diambil lewat indeks hasil filter, sehingga
  // tiap kartu menampilkan angka milik kategori lain begitu kotak pencarian dipakai.
  const kateList = kates.map((kate, index) => ({
    ...kate,
    jumlahSubkat: subkat[index],
    jumlahParameter: parameter[index],
  }));

  // Memfilter kates berdasarkan query pencarian
  const filteredKates = kateList.filter(kate => kate.nm_kategory.toLowerCase().includes(query.toLowerCase()));

  return (
    <div className="main-wrapper">
      <Header2/>
      
      {/* Page Wrapper */}
      
      <div className="page-content">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              {/* Filter */}
              <div className="showing-list">
                <div className="row">
                  <div className="col-lg-8">
                    <div className="d-flex align-items-center">
                      <div className="view-icons">
                        <Link className="list-view active">
                          <List />
                        </Link>
                      </div>
                      <div className="show-result">
                      <h4>Showing {filteredKates.length} results</h4> {/* Dinamis sesuai hasil filter */}
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-4">
                    <div className="show-filter add-course-info">
                      <form action="#">
                        <div className="row gx-2 align-items-center">
                          <div className="col-md-12 col-item">
                            <div className=" search-group">
                              <Search
                                size={16}
                                style={{
                                  position: "absolute",
                                  left: "7px",
                                  color: "#027333",
                                }}
                              />
                              <input
                                type="text"
                                value={query}
                                onChange={(e) => setQuery(e.target.value)}
                                className="form-control"
                                placeholder="Search our courses"
                              />
                            </div>
                          </div>
                         
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
              {/* Filter */}

              <div className="row">
                {loading ? (
                  <center>
                    <div className="spinner-border text-center" style={{ marginTop: "20px" }}></div> 
                  </center>
                  
                ) : error ? (
                  <center>
                    <p style={{ marginTop: "20px" }}>{error}</p>
                  </center>
                ) :
                
                
                filteredKates.map((kategori) => (
                  <ListKat
                    key={kategori.id}
                    title={kategori.nm_kategory}
                    id={kategori.id}
                    komoditi={komo}
                    subkat={kategori.jumlahSubkat}
                    parameter={kategori.jumlahParameter}
                    image={image}
                  />
                ))
                }
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Page Wrapper */}
      <Footer />
    </div>
  );
};
Kategory.propTypes = {
  id: PropTypes.number.isRequired, // Define title as required string
};
export default Kategory;